// @flow
import Button from 'antd/lib/button';
import Modal from 'antd/lib/modal';
import notification from 'antd/lib/notification';
import Upload from 'antd/lib/upload';
import { FormikProps } from 'formik';
import * as React from 'react';
import { Form } from '../../../../components';
import { notificationLoading } from '../../../../components/Notifications';
import { Grid, GridItem } from '../../../../components/layout';
import { apiUrl } from '../../../../lib/api';
import tokenManager from '../../../../lib/tokenManager';
import type { User } from '../../../../lib/types';
import { withUserAccess } from '../../../withUserAccess';

type FileData = {
  file: any,
};

type Props = {
  visible: boolean,
  onClose: Function,
  userProfile: User,
  employeeBranchOrgUnitId: number,
  updateTripList: Function,
  registryId: number,
};

type State = {
  data: FileData,
  disableSubmitButton: boolean,
};

class UpdateTripListModal extends React.Component<Props, State> {
  state = {
    data: {},
    disableSubmitButton: false,
  };

  render() {
    const {onClose, visible, updateTripList, registryId} = this.props;
    const {data, disableSubmitButton} = this.state;

    return (
      <Modal
        onCancel={onClose}
        visible={visible}
        destroyOnClose
        width={600}
        title="Загрузка в реестр ПЛ НТС"
        footer={false}
      >
        <Form initialValues={data} onSubmit={false}>
          {(FormField, formikProps: FormikProps) => {
            return (
              <form onSubmit={formikProps.handleSubmit}>
                <Grid gutter="16px">
                  <GridItem>
                    <Upload
                      accept=".xlsx"
                      showUploadList={false}
                      action={`${apiUrl}/ContractTrip/ImportAdditional`}
                      data={{
                        id: registryId
                      }}
                      headers={{
                        Authorization: `Bearer ${tokenManager.getToken()}`,
                      }}
                      beforeUpload={() => {
                        this.setState({disableSubmitButton: true});
                        notificationLoading({
                          message: 'Сохранение данных',
                          key: 'sending',
                        });
                      }}
                      onChange={({file}) => {
                        const {status, response} = file;
                        switch (status) {
                          case 'done':
                            notification.close('sending');
                            notification.success({
                              message: 'Данные сохранены',
                              description: response,
                              duration: 8,
                            });
                            this.setState({disableSubmitButton: false});
                            onClose();
                            updateTripList();
                            break;
                          case 'error':
                            notification.close('sending');
                            notification.error({
                              message: 'Ошибка',
                              description: response.title || response.message,
                              duration: null,
                            });
                            this.setState({disableSubmitButton: false});
                            break;
                          default:
                            break;
                        }
                      }}
                    >
                      <Button
                        disabled={disableSubmitButton}
                        htmlType="submit"
                        type="primary"
                      >
                        Выбрать файл и отправить данные
                      </Button>
                    </Upload>
                  </GridItem>
                </Grid>
              </form>
            );
          }}
        </Form>
      </Modal>
    );
  }
}

export default withUserAccess(UpdateTripListModal);
